import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const TerrainFilledIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="m14 6-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22z" fill="currentColor" />
  </svg>
);

TerrainFilledIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(TerrainFilledIcon);
